import Testing from "../components/Testing";

function TestingPage() {
  return <Testing />;
}

export default TestingPage;
